<ng-container *transloco="let t">
  <div class="dialog-overlay" (click)="onClose()">
    <div class="dialog-container" (click)="$event.stopPropagation()">
      <!-- Header -->
      <div class="dialog-header">
        @if (mode === 'info') {
          <h2 class="dialog-title">{{ t('lang.share_info_title_view') }}</h2>
          <p class="dialog-subtitle">
            {{ t(shareInfoSubtitleViewKey, { entity: integrationEntityName }) }}
          </p>
        } @else {
          <h2 class="dialog-title">{{ t('lang.share_info_title') }}</h2>
          <p class="dialog-subtitle">
            {{ t(shareInfoSubtitleKey, { entity: integrationEntityName }) }}
          </p>
        }
        <button class="close-button" (click)="onClose()">
          <mzic-svg src="assets/icons/mzic-close.svg" />
        </button>
      </div>

      <!-- Content -->
      <div class="dialog-content">
        <!-- URL Field -->
        <div class="info-field">
          <label class="field-label">{{ t('lang.share_info_url_label') }}</label>
          <div class="field-value-container">
            <div class="field-value url-value">
              <span class="value-text">{{ shareUrl }}</span>
            </div>
            <button class="copy-button" (click)="copyUrl()">
              @if (urlCopied()) {
                <mzic-svg src="assets/icons/mzic-check-mark-filled.svg" />
                <span>{{ t('lang.copied') }}</span>
              } @else {
                <mzic-svg src="assets/icons/mzic-copy.svg" />
                <span>{{ t('lang.copy') }}</span>
              }
            </button>
          </div>
        </div>

        <!-- Passcode Field -->
        <div class="info-field">
          <label class="field-label">{{ t('lang.share_info_passcode_label') }}</label>
          <div class="field-value-container">
            <div class="field-value passcode-value">
              <span class="passcode-text">{{ passcode }}</span>
            </div>
            <button class="copy-button" (click)="copyPasscode()">
              @if (passcodeCopied()) {
                <mzic-svg src="assets/icons/mzic-check-mark-filled.svg" />
                <span>{{ t('lang.copied') }}</span>
              } @else {
                <mzic-svg src="assets/icons/mzic-copy.svg" />
                <span>{{ t('lang.copy') }}</span>
              }
            </button>
          </div>
        </div>

        <!-- Expires At Field -->
        <div class="info-field">
          <label class="field-label">{{ t('lang.share_info_expires_label') }}</label>
          <div class="field-value expires-value">
            <mzic-svg src="assets/icons/mzic-clock.svg" />
            <span>{{ formattedExpiresAt }}</span>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="dialog-footer">
        @if (mode === 'info') {
          <button
            class="revoke-button"
          [disabled]="revoking"
          (click)="onRevoke()">
          @if (revoking) {
              <mzic-spinner></mzic-spinner>
              {{ t('lang.share_info_revoking') | uppercase }}
            } @else {
              {{ t('lang.share_info_revoke') | uppercase }}
            }
          </button>
          <button class="secondary-button" (click)="onClose()">
            {{ t('lang.share_info_close') | uppercase }}
          </button>
        } @else {
          <button class="primary-button" (click)="onClose()">
            {{ t('lang.share_info_done') | uppercase }}
          </button>
        }
      </div>
    </div>
  </div>
</ng-container>
